import { render } from "./TextareaInput.vue?vue&type=template&id=6d2651c3"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__